import { render, staticRenderFns } from "./RemindPassword.vue?vue&type=template&id=5c5059a4"
import script from "./RemindPassword.vue?vue&type=script&lang=js"
export * from "./RemindPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports